"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isInMinMaxBounds = function isInMinMaxBounds(date, min, max) {
  if (!date) return true;
  var passesMinCheck = !min || date.isSameOrAfter((0, _moment["default"])(min), 'day');
  var passesMaxCheck = !max || date.isSameOrBefore((0, _moment["default"])(max), 'day');
  return passesMinCheck && passesMaxCheck;
};

var _default = isInMinMaxBounds;
exports["default"] = _default;